import { render, staticRenderFns } from "./SignaturePad.vue?vue&type=template&id=237c8fb0"
import script from "./SignaturePad.vue?vue&type=script&lang=js"
export * from "./SignaturePad.vue?vue&type=script&lang=js"
import style0 from "./SignaturePad.vue?vue&type=style&index=0&id=237c8fb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports